// eslint-disable-next-line import/prefer-default-export
export const TOOLTIP_POSITIONS = ["bottom", "left", "right", "top"];